<template>
  <tr v-if="requirement.editing" class="requirement row qualification-category editing" key="editing">
    <can I="edit" a="Opportunity">
      <th v-if="first" class="text-xs-right">Qualification</th>
      <td v-else class="text-xs-right">
        {{ requirement.mandatory ? 'and' : 'or'}}
      </td>
      <td colspan="2">
        <v-toolbar flat class="transparent">
          <v-select v-model="requirement.mandatory" :items="[{ text: 'must', value: true }, { text: 'could', value: false }]" />
          <label class="body px-2">be</label>
          <v-select v-model="requirement.negative" :items="[{ text: 'outside', value: true }, { text: 'in', value: false }]" />
          <label class="body px-2">category</label>
          <v-select v-if="qualificationCategories.length > 0" v-model="requirement.value" :items="qualificationCategories" item-text="name" item-value="name" />

          <v-spacer />

          <!-- Cancel Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn key="cancel" small flat fab
              slot="activator"
              @click="cancel"
              color="grey"
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <span>Cancel</span>
          </v-tooltip>

          <!-- Delete Button -->
          <v-tooltip left v-if="requirement.id" color="grey darken-3">
            <v-btn small flat error fab
            slot="activator"
            key="delete"
            @click="destroy"
            color="error"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
            <span>Delete</span>
          </v-tooltip>

          <!-- Submit Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small fab
              slot="activator"
              @click="submit"
              key="save"
              color="primary"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <span v-if="requirement.id">Update</span>
            <span v-else>Create</span>
          </v-tooltip>
        </v-toolbar>
      </td>
    </can>
  </tr>
  <tr v-else class="requirement row qualification-category viewing" key="viewing">
    <th v-if="first" class="text-xs-right">Qualification</th>
    <td v-else class="text-xs-right">
      {{ requirement.mandatory ? 'and' : 'or' }}
    </td>
    <td>
      {{ requirement.mandatory ? 'must' : 'could' }}
      be
      {{ requirement.negative ? 'outside' : 'in' }}
      category
      <em>{{ requirement.qualificationCategory.name }}</em>
    </td>
    <td class="text-xs-right">
      <can I="edit" a="Opportunity">
        <v-btn small flat @click.prevent="edit" color="primary">
          Edit
        </v-btn>
      </can>
    </td>
  </tr>
</template>

<script>
// Vue Component
export default {
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean }
  },
  created() {
    this.$http.get('qualification_categories').then(response => {
      // Set options
      let options = response.data.map(o => Object.assign(o, { id: o.id.toString() }))

      // In-place sort by display attribute (case insensitive)
      options.sort((a, b) => {
        const first = a['name'].toUpperCase()
        const second = b['name'].toUpperCase()

        if (first < second) return -1
        if (first > second) return 1
        return 0
      })

      // Store options
      this.qualificationCategories = options
    })
  },
  data() {
    return {
      qualificationCategories: []
    }
  },
  computed: {
    creating() {
      this.requirement.id == null
    }
  },
  methods: {
    edit() {
      this.requirement.editing = true
    },
    cancel() {
      this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      this.requirement.editing = false
    },
    destroy() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/destroy', this.requirement)
      } else {
        this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      }
    },
    submit() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/update', this.requirement).then(feedback => {
          if (feedback) {
            this.$store.commit('snackbar', { text: 'There was a problem updating the requirement', type: 'error' })
            this.requirement = feedback
          } else {
            this.$store.commit('snackbar', { text: 'Requirement was updated successfully', type: 'success' })
          }
        })
      } else {
        this.$store.dispatch('requirements/create', this.requirement).then(feedback => {
          if (feedback) {
            this.$store.commit('snackbar', { text: 'There was a problem creating the requirement', type: 'error' })
            this.requirement = feedback
          } else {
            this.$store.commit('snackbar', { text: 'Requirement was created', type: 'success' })
          }
        })
      }
    }
  }
}
</script>
